module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1200@2x-e02351597956f076ad1796c1717de2d4.webp";